import React from "react";
import PropTypes from "prop-types";
import TopBar from "../components/common/topBar/TopBar";
import Footer from "../components/common/footer/Footer";
import styles from "./DefaultLayout.module.scss";

const DefaultLayout = (props) => {
  const {children, topbar, navigation, footer} = props;
  return (
    <div className="layout-section">
      {topbar}
      {navigation}
      <div className={styles.siteContainer}>
        <div className={styles.siteSubCont}>
          <main id="sectionMain" style={{minHeight: "400px"}}>{children}</main>
        </div>
      </div>
      {footer}
    </div>
  );
};

DefaultLayout.propTypes = {
  topbar: PropTypes.element,
  navigation: PropTypes.element,
  footer: PropTypes.element
};

DefaultLayout.defaultProps = {
  topbar: <TopBar/>,
  navigation: null,
  footer: <Footer/>
};

export default DefaultLayout;
